import Cookie from 'js-cookie';

const LANGUAGE_COOKIE_DAYS = 30;

export const changeLanguage = (code: string) => {
  Cookie.set('language', code, {
    expires: LANGUAGE_COOKIE_DAYS,
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'lax',
  });
  window.location.reload();
};
